/* eslint-disable no-undef */
import {ApiClientService} from '@dofleini/security';
import {API_SETTINGS} from '../constants/api.settings';
import {USER_PROFILE} from '../constants/storage.variables';



export const setProfile = (profile) => {
  sessionStorage.setItem(USER_PROFILE, profile);
};

export const getProfile = () => {
  sessionStorage.getItem(USER_PROFILE);
};

class Authorization {

  constructor() {
    this.settings = {
      serverApi: process.env.REACT_APP_BACKEND_URL
    };

    this.service = ApiClientService;

  }

  signUp = (params) => {
    return this.service.post(`${API_SETTINGS.auth}/signup`, params);
  };

  requestAccess = (params) => {
    return this.service.post(`${API_SETTINGS.auth}/access-requests`, params);
  };

  processAccess = (key, accept) => {
    return this.service.post(`${API_SETTINGS.auth}/process-access`, {key, accept});
  };

  signIn = (params) => {
    return this.service.post(`${API_SETTINGS.auth}/signin`, params);
  };

  refreshToken = (params) => {
    return this.service.post(`${API_SETTINGS.auth}/refresh-token`, params);
  };


  checkConfirmationAccess = (key) => {
    return this.service.post(`${API_SETTINGS.auth}/confirm`, {key})
      .then(r => r.data);
  };

  invitationAccess = (key) => {
    return this.service.post(`${API_SETTINGS.auth}/accept-invite`, {key})
      .then(r => r.data);
  };

  resendConfirmationAccess = (data) => {
    return this.service.post(`${API_SETTINGS.auth}/confirm/resend`, data)
      .then(r => r.data);
  };

  resendConfirmationAccessFromStorage = (identifier) => {
    return this.service.post(`${API_SETTINGS.auth}/confirm/resend`, {identifier})
      .then(r => r.data);
  };

  checkConfirmationMessage = (key) => {
    const phone = getProfile().phone;
    return this.service.post(`${API_SETTINGS.auth}/confirm-phone`, {key, phone}).then(r => r.data);
  };

  resendPhoneAccess = () => {
    console.log('send message to:', getProfile().phone);
  };
}

export default new Authorization();
